import React from "react";

export default function DeleteAccount() {
  return (
    <>
      <style>{`
        body {
          background-image: url('/F.jpg');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          font-family: 'Poppins', sans-serif;
          margin: 0;
        }

        .terms-main-container {
          margin: 2rem auto;
          padding: 2rem;
          max-width: 800px;
          background-color: rgba(255, 255, 255, 0.164);
          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.363);
          backdrop-filter: blur(30px);
          border: 2px solid rgba(255, 255, 255, 0.24);
          border-radius: 20px;
        }
        .terms-header {
          text-align: center;
          margin-bottom: 1rem;
        }
        .terms-header img {
          display: block;
          margin: 0 auto 1rem;
          width: 100px;
        }
        .terms-header h1 {
          font-size: 2rem;
          color: rgb(15, 133, 202);
          margin-bottom: 0.5rem;
        }
        .terms-header hr {
          border: none;
          border-top: 2px solid rgba(15, 133, 202, 0.5);
          margin: 0 auto;
          width: 50%;
        }
        .first-block {
          margin-top: 2rem;
        }
        .terms-title {
          font-size: 1.5rem;
          color: rgb(15, 133, 202);
          margin-bottom: 0.5rem;
        }
        .terms-info {
          color: white;
          font-size: 1rem;
          line-height: 1.5;
          margin-bottom: 1rem;
        }
        .term-list {
          margin-left: 1.5rem;
          color: white;
          font-size: 0.9rem;
          list-style: disc;
        }
        .term-list li {
          margin-bottom: 0.5rem;
        }
        .ending-terms {
          color: rgb(216, 225, 255);
          text-align: center;
          margin-top: 2rem;
          font-style: italic;
        }
        .email-link {
          color: rgb(100, 200, 255);
          text-decoration: underline;
        }
        .steps-list {
          margin-left: 1.5rem;
          color: white;
          font-size: 0.95rem;
          list-style: decimal;
          line-height: 1.8;
        }
        .steps-list li {
          margin-bottom: 0.5rem;
        }
        .highlight {
          color: rgb(100, 200, 255);
          font-weight: 600;
        }
        .note-box {
          margin-top: 1.5rem;
          padding: 1rem 1.25rem;
          background-color: rgba(255, 255, 255, 0.08);
          border-left: 4px solid rgb(15, 133, 202);
          border-radius: 8px;
          color: white;
          font-size: 0.95rem;
          line-height: 1.6;
        }
      `}</style>

      <div className="terms-main-container">
        <img src="/wayuvega.png" alt="Wayuvega Logo" />

        <section className="terms-header">
          <h1>Delete Your Account</h1>
          <hr />
        </section>

        <div className="terms-body">
          <div className="first-block">
            <p className="terms-info">
              If you wish to delete your Wayuvega account and all associated data,
              please follow the steps below. We will process your request and
              permanently remove your personal data from our systems.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">How to Request Account Deletion</p>
            <ol className="steps-list">
              <li>
                Send an email to{" "}
                <a className="email-link" href="mailto:support@wayuvega.com">
                  support@wayuvega.com
                </a>
              </li>
              <li>
                Use the subject line:{" "}
                <span className="highlight">"Account Deletion Request"</span>
              </li>
              <li>
                Include your registered <span className="highlight">phone number</span>{" "}
                and/or <span className="highlight">email address</span> in the body of the email
              </li>
            </ol>
          </div>

          <div className="first-block">
            <p className="terms-title">What Happens Next</p>
            <ul className="term-list">
              <li>
                Our team will verify your identity and process your deletion request
                within <strong>3–5 working days</strong>.
              </li>
              <li>
                You will receive a confirmation email once your account and data have
                been deleted.
              </li>
              <li>
                Once deleted, your account cannot be recovered. Any shipments,
                transaction history, and personal information linked to your account
                will be permanently removed.
              </li>
            </ul>
          </div>

          <div className="first-block">
            <p className="terms-title">Data We Delete</p>
            <ul className="term-list">
              <li>Your profile information (name, email, phone number)</li>
              <li>Shipment and order history</li>
              <li>Wallet and transaction records</li>
              <li>Saved addresses and preferences</li>
              <li>Support tickets and communication history</li>
            </ul>
          </div>

          <div className="first-block">
            <p className="terms-title">Data Retention</p>
            <p className="terms-info">
              Certain data may be retained for a limited period as required by applicable
              laws, regulations, or legitimate business purposes (e.g., financial
              records for tax compliance). Such data will be securely stored and deleted
              once the retention period expires.
            </p>
          </div>

          <div className="note-box">
            <strong>Need help?</strong> If you have any questions about the deletion
            process, feel free to contact us at{" "}
            <a className="email-link" href="mailto:support@wayuvega.com">
              support@wayuvega.com
            </a>.
          </div>

          <p className="ending-terms">
            Thank you for being a part of Wayuvega. We respect your privacy and your
            right to control your data.
          </p>
        </div>
      </div>
    </>
  );
}
